import { message } from '@/components';
import { note } from '@/models';
import { elkLog } from '@/utils/elkReport';
import { useIntl } from 'umi';
export interface NotePermissionChangeResp {
  channelId: string; // 会议房间ID
  permission: number; // 共享屏幕批注权限 1-所有人可批注 2-仅共享人可批注
}
export default function useNotePermissionChange() {
  const { formatMessage } = useIntl();

  const change = async (body: NotePermissionChangeResp) => {
    if (isMobile) {
      return;
    }
    if (body.permission === 1) {
      message.info({
        content: formatMessage({ id: 'setSharertoAnnotateAll' }),
        noIcon: true,
      });
      note?.setShareAnnotatePermission(body.permission);
    }
    if (body.permission === 2) {
      message.info({
        content: formatMessage({ id: 'setSharertoAnnotate' }),
        noIcon: true,
      });
      note?.setShareAnnotatePermission(body.permission);
    }
    elkLog('收到批注权限变更通知', body);
  };
  return change;
}
